import Card from "@material-ui/core/Card";
import {ButtonBase, Divider, Grid} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import NavIcon from "@material-ui/icons/ArrowForwardIosRounded";
import React from "react";
import CardContent from "@material-ui/core/CardContent";
import {DoneRounded, AccessTimeRounded} from "@material-ui/icons";

export function CardPedido(props) {
    const {id, fecha, cliente, tipoEscaneo, escaneado1, escaneado2, onClick} = props;
    return (
        <>
            <Card className={'m-0 p-0'} elevation={0}>
                <ButtonBase style={{width: '100%', display: 'block', textAlign: 'left'}} onClick={onClick}>
                    <CardContent>
                        {(tipoEscaneo === 1 && escaneado1) || (tipoEscaneo === 2 && escaneado2) ?
                            <>
                                <Typography variant={"caption"} component={"span"} color={"primary"} className={'mb-2 d-flex'}>
                                    <DoneRounded fontSize={"small"} color={"primary"} className={'mr-1'}/><b>{tipoEscaneo === 1 ? 'Validado' : 'En camión'}</b>
                                </Typography>
                            </>
                            :
                            <>
                                <Typography variant={"caption"} component={"span"} color={"textSecondary"} className={'mb-2 d-flex'}>
                                    <AccessTimeRounded fontSize={"small"} color={"disabled"} className={'mr-1'}/><b>Pendiente</b>
                                </Typography>
                            </>
                        }
                        <Grid container alignItems={"center"}>
                            <Grid item xs={11}>
                                <Typography color="textSecondary" gutterBottom>
                                    Pedido {id}
                                </Typography>
                                <Typography color="textSecondary">
                                    {cliente}
                                </Typography>
                            </Grid>
                            <Grid item xs={1}>
                                <NavIcon color={"primary"}/>
                            </Grid>
                        </Grid>
                    </CardContent>
                </ButtonBase>
            </Card>
            <Divider/>
        </>
    );
}
